import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AuthApi } from "../../../api/AuthApi";

const initialState = {
  status: false,
  message: "",
  data: {},
  currentRequestId: undefined,
  loading: "idle",
  action: "",
  error: null,
};
export const pulsar = createAsyncThunk(
  "wallet/pulsar",
  async (pulsarData, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().pulsar_wallet;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await AuthApi.pulsar();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const generateAddress = createAsyncThunk(
  "wallet/generateAddress",
  async (address, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().pulsar_wallet;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await AuthApi.generateAddress();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const sendPulsar = createAsyncThunk(
  "wallet/sendPulsar",
  async (payload, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().pulsar_wallet;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await AuthApi.sendPulsar({ values: payload });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const transactions = createAsyncThunk(
  "wallet/transactions",
  async (payload, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().pulsar_wallet;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await AuthApi.getTransactions();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const explorer = createAsyncThunk(
  "wallet/explorer",
  async (payload, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().pulsar_wallet;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await AuthApi.getExplorerData();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const explorerRecords = createAsyncThunk(
  "wallet/explorerRecords",
  async (payload, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().pulsar_wallet;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await AuthApi.explorerRecords();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const resetSendPulsar = createAsyncThunk(
  "wallet/resetSendPulsar",
  async ({ rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().pulsar_wallet;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = initialState;
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const searchPulsar = createAsyncThunk(
  "wallet/searchPulsar",
  async (payload, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().pulsar_wallet;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await AuthApi.searchPulsar(payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const pulsarSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(pulsar.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.action = "pulsar";
          state.error = null;
        }
      })
      .addCase(pulsar.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, pulsar_data: action.payload.data };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(pulsar.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(generateAddress.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.action = "generate_address";
          state.error = null;
        }
      })
      .addCase(generateAddress.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, new_address_data: action.payload.data };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(generateAddress.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(sendPulsar.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.action = "send_Pulsar";
          state.error = null;
        }
      })
      .addCase(sendPulsar.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, send_data: action.payload.data };
          state.status = action.payload.status;
          state.error = null;
          state.currentRequestId = undefined;
        }
      })
      .addCase(sendPulsar.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(transactions.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.action = "get_transactions";
          state.error = null;
        }
      })
      .addCase(transactions.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, transaction_data: action.payload.data };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(transactions.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(explorer.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.action = "get_explorer";
          state.error = null;
        }
      })
      .addCase(explorer.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, explorer: action.payload.data };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(explorer.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(resetSendPulsar.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.action = "";
          state.error = null;
        }
      })
      .addCase(resetSendPulsar.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, send_data: "" };
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(resetSendPulsar.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error = null;
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(explorerRecords.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.action = "explorer_records";
          state.error = null;
        }
      })
      .addCase(explorerRecords.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, explorer_records: action.payload.data };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(explorerRecords.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(searchPulsar.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.action = "search_pulsar";
          state.error = null;
        }
      })
      .addCase(searchPulsar.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, search_pulsar: action.payload.data };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(searchPulsar.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      });
  },
});

export default pulsarSlice.reducer;
